import React from 'react';
import PropTypes from 'prop-types';
import { ActionIcon } from '@mantine/core';
import { TextSize, X } from 'tabler-icons-react';
import AppStack from '../../common/AppStack';
import AppFlexbox from '../../common/AppFlexbox';
import AppText from '../../common/AppText';
import * as classes from '../../../styles/nestedStyles.module.css';

const PERSONALIZE_OPTIONS = [
  {
    label: 'Add Personalized Text',
    value: 'personalize',
    Icon: TextSize
  }
];

const PrintDesignEditorToolbarMenu = ({
  canvasController,
  action,
  onClose
}) => {
  const { addPersonalizedTextbox } = canvasController;
  const title = action === 'personalize' ? 'Personalize' : '';

  const onPersonalizeOptionClick = (option) => {
    if (option.value === 'personalize') {
      addPersonalizedTextbox();
      onClose();
    }
  };

  return (
    <AppStack
      style={{
        height: '100%',
        padding: 16,
        gap: 24
      }}
    >
      <AppFlexbox
        style={{
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <AppText style={{ fontSize: 18, fontWeight: 500 }}>{title}</AppText>

        <ActionIcon onClick={onClose} variant="subtle">
          <X color="#000" size={20} />
        </ActionIcon>
      </AppFlexbox>

      <AppStack style={{ gap: 16 }}>
        {action === 'personalize' ? (
          <>
            <AppText style={{ fontSize: 14 }}>
              Allow customers to personalize their product by adding custom
              text.
            </AppText>

            {PERSONALIZE_OPTIONS.map((option) => (
              <AppFlexbox
                key={option.value}
                className={classes['hover-action-card']}
                onClick={() => onPersonalizeOptionClick(option)}
                style={{
                  padding: 16,
                  gap: 16,
                  alignItems: 'center',
                  border: 'solid 1px #000'
                }}
              >
                <option.Icon size={16} />
                <AppText>{option.label}</AppText>
              </AppFlexbox>
            ))}
          </>
        ) : null}
      </AppStack>
    </AppStack>
  );
};

PrintDesignEditorToolbarMenu.propTypes = {
  canvasController: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  action: PropTypes.string
};

export default PrintDesignEditorToolbarMenu;
